import Header from "components/Headers/Header.js";

const Index = () => {
  return (
    <>
      <div className="min-vh-100">
        <Header />
      </div>
    </>
  );
};

export default Index;
